export const offerData = [
    {
        id: 601,
        name: "Акција - Чикен чизбургер + мали помфрит + кока кола 0,33",
        subtitle: "",
        desc: "150г паниране пилетине, 2x трапист сир, фета сир, микс салата, сосеви",
        grams: "",
        price: "720",
        image: "https://idzuo.com/menuImages/offers/offer-01.png ",
        cart: "Додајте у корпу",
    },
    {
        id: 602,
        name: "Акција - 2 x Classic Idzuo smash + мали помфрит",
        subtitle: "",
        desc: "2x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
        grams: "",
        price: "1040",
        image: "https://idzuo.com/menuImages/offers/offer-02.png",
        cart: "Додајте у корпу",
    },
    {
        id: 603,
        name: "Акција - Омлет са панчетом у тортиљи",
        subtitle: "",
        desc: "2 јаја, панчета, фета сир, кисели краставчићи, микс салата, сосеви",
        grams: "",
        price: "288",
        image: "https://idzuo.com/menuImages/breakfast/omlet_sa_pancetom_u_tortilji.jpg",
        cart: "Додајте у корпу",
    },    
];